import Icon from '../components/Icon.vue'

Icon.register({"plus-square":{"width":448,"height":512,"paths":[{"d":"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM368 284C368 290.6 362.6 296 356 296H264V388C264 394.6 258.6 400 252 400H196C189.4 400 184 394.6 184 388V296H92C85.4 296 80 290.6 80 284V228C80 221.4 85.4 216 92 216H184V124C184 117.4 189.4 112 196 112H252C258.6 112 264 117.4 264 124V216H356C362.6 216 368 221.4 368 228V284z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/plus-square.js
// module id = Q3p+
// module chunks = 0